(ns ui.totp.core
  "Core totp ns with query-kind, expiredate calculation."
  (:require [parts.replicant.query :as query]))

(def totp-query
  {:query/kind :query/totp})

(defn calc-expire-time
  [state]
  (let [expire-timestamp (get-in (query/get-result state totp-query)
                                 [:totp :totp/expire-timestamp])]
    (-> (/ (- expire-timestamp
              (:ui/clock state))
           30000)
        (max 0)
        (min 1))))

(defn totp-slider
  [progress]
  [:div.w-10.bg-gray-100.rounded-3xl.h-2.5.ml-4
   [:div {:class "bg-indigo-600 h-2.5 rounded-3xl transition-all"
          :style {:width (str (* 100 progress) "%")}}]])